import { Component, OnInit, ViewChild, Input, ElementRef, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import * as _ from 'lodash';
import createResizeObserver from '../../../core/helpers/resizeObserver';
import { FoldableItem } from './foldable-item';

const RESIZE_OBSERVER = createResizeObserver();
const MARGIN_LEFT = 8; // .foldable-content__item + .foldable-content__item { margin-left: 6px }

@Component({
  selector: 'foldable-content',
  templateUrl: './foldable-content.component.html',
  styleUrls: ['./foldable-content.component.css']
})
export class FoldableContentComponent implements OnInit {

  @Input() items: Array<any>;
  @Input() bindLabel: string | boolean = null;
  @Input() ngClass: any;
  @Input() ngStyle: any;
  @Input() contentWidth?: number;
  @Input() renderMin?: number;
  @Input() renderMax?: number;

  content: Array<FoldableItem> = [];
  height: number;
  firstPaint = false;
  debug = false;
  fn: () => void;

  @ViewChild('wrapper') wrapperElement: ElementRef;
  @ViewChild('content') contentElement: ElementRef;
  @ViewChild('counter') counterElement: ElementRef;

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit() {
    const itemsAmount = (this.items) ? this.items.length : 0;
    if (itemsAmount === 0) return
    this.content = this.items.map<any>((item, index) => {
      return {
        content: item,
        rendered: (this.contentWidth !== undefined || index === 0)
      }
    })

    if (itemsAmount > 1) {
      this.fn = this.calc.bind(this)
      RESIZE_OBSERVER.addListener(this.fn)

      if (this.checkWidth()) return

      this.fn()
      setTimeout(() => {
        this.fn()
      }, 10)
    }
    // @ts-ignore
    requestAnimationFrame(() => void requestAnimationFrame(() => void $('[data-toggle="popover"]').popover()));
  }

  ngOnDestroy() {
    if (this.fn) {
      RESIZE_OBSERVER.removeListener(this.fn)
    }
  }

  checkWidth() {
    if (this.contentWidth !== undefined) {
      requestAnimationFrame(() => {
        this.content.forEach((i) => void (i.rendered = true))
        this.cd.detectChanges()
        const nativeEl = this.wrapperElement.nativeElement
        const counterEl = this.counterElement.nativeElement
        const contentAmount = this.content.length
        let acc = 0
        for (let i = 0; i < contentAmount; ++i) {
          const nativeElWidth = Math.floor(nativeEl.getBoundingClientRect().width) - Math.ceil(counterEl.getBoundingClientRect().width) - (MARGIN_LEFT * 4)
          const content = this.content[i]
          acc += +this.contentWidth + (MARGIN_LEFT * 2)

          if (typeof this.renderMin === 'number') {
            if ((i > this.renderMin && acc > nativeElWidth) || (this.renderMax && i >= this.renderMax)) {
              content.rendered = false
            } else {
              content.rendered = true
            }
          } else {
            if ((i !== 0 && acc > nativeElWidth) || (this.renderMax && i >= this.renderMax)) {
              content.rendered = false
            } else {
              content.rendered = true
            }
          }
        }

        this.firstPaint = true

        this.cd.detectChanges()
      })

      return true
    }

    return false
  }

  calc() {
    if (this.checkWidth()) return

    requestAnimationFrame(() => {
      this.content.forEach((i, index) => i.rendered = index === 0)
      const wrapperEl = this.wrapperElement.nativeElement
      const contentAmount = this.content.length
      const initialHeight = this.height || (this.height = wrapperEl.getBoundingClientRect().height)
      requestAnimationFrame(() => {
        for (let i = 1; i < contentAmount; ++i) {
          const content = this.content[i]
          content.rendered = true
          this.cd.detectChanges()
          if (wrapperEl.getBoundingClientRect().height > initialHeight || (this.renderMax && i >= this.renderMax)) {
            content.rendered = false
            // break // we could break the loop for performance improvement, but we want nice and fully responsive UI :)
          }
        }
        this.cd.detectChanges()
      })
    })
  }

  hasHiddenItems() {
    return this.hiddenItems.length > 0;
  }

  getRendering(value: any) {
    return this.bindLabel === false ? '' : (this.bindLabel ? value.content[this.bindLabel as string] : value.content)
  }

  get getTooltip() {
    if (!this.hiddenItems || this.hiddenItems.length === 0) return []
    return this.hiddenItems.map((item) => this.hasImage(item) ? this.getImageRenderingTitle(item) : this.getRendering(item))
  }

  get renderedItems() {
    return this.content.filter((i) => i.rendered);
  }

  get hiddenItems() {
    return this.content.filter((i) => !i.rendered);
  }

  getRenderingStyling(item) {
    return this.ngStyle || item.content.ngStyle;
  }

  getRenderingClass(item) {
    return this.ngClass || item.content.ngClass;
  }

  hasImage(item) {
    return item.content && item.content.imgSrc;
  }

  getImageSource(item) {
    return this.hasImage(item) ? item.content.imgSrc : '';
  }

  getImageRenderingClass(item) {
    return this.hasImage(item) ? item.content.imgNgClass : '';
  }

  getImageRenderingStyling(item) {
    return this.hasImage(item) ? item.content.imgNgStyle : '';
  }

  getImageRenderingTitle(item) {
    return this.hasImage(item) ? item.content.imgTitle : ''
  }

  get getTooltipText() {
    return this.getTooltip.join('<br/>');
  }

}
